var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ISwitch',{attrs:{"value":_vm.value,"active-text":_vm.onText,"inactive-text":_vm.offText},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }